import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useGetInventoryCountQuery } from '../../redux/api/inventoryApi';

const SOURCE_LABEL = {
  WAREHOUSE: 'Lager',
  MARKT: 'Markt',
  COMBINED: 'Lager + Markt',
};
const fmt = (iso) => new Date(iso).toLocaleString('de-DE');

const InventoryCountDetail = () => {
  const { id } = useParams();
  const { data: count, isLoading } = useGetInventoryCountQuery(id);

  if (isLoading) {
    return <p className='mt-4'>Inventur wird geladen...</p>;
  }
  if (!count) {
    return <p className='mt-4'>Inventur nicht gefunden.</p>;
  }

  return (
    <div>
      <h4 className='mt-2'>Inventur vom {fmt(count.created_at)}</h4>
      <p className='text-muted mb-1'>
        Erfasst von: {count.created_by_username || '—'}
      </p>
      {count.note ? <p className='text-muted'>Notiz: {count.note}</p> : null}

      <table className='table table-striped mt-3 align-middle text-start'>
        <thead>
          <tr>
            <th>Bereich</th>
            <th>Artikel</th>
            <th className='text-end'>Soll</th>
            <th className='text-end'>Gezählt</th>
            <th className='text-end'>Differenz</th>
          </tr>
        </thead>
        <tbody>
          {count.items.map((it) => (
            <tr key={it.id}>
              <td>{SOURCE_LABEL[it.source] || it.source}</td>
              <td>{it.article_name}</td>
              <td className='text-end'>{it.should_be_quantity}</td>
              <td className='text-end'>{it.counted_quantity}</td>
              <td
                className={`text-end ${
                  it.difference !== 0 ? 'table-warning fw-bold' : ''
                }`}
              >
                {it.difference > 0 ? `+${it.difference}` : it.difference}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Link to='/inventory-counts' className='btn btn-outline-secondary btn-sm'>
        Zurück zur Übersicht
      </Link>
    </div>
  );
};

export default InventoryCountDetail;
